import mixpanel from 'mixpanel-browser';

import { Analytics } from '@/features/analytics/service/Analytics';
import type { EventProperties } from '@/features/analytics/types/EventProperties';
import { getEnvVar } from '@/shared/utils/envVarConfig';

export class MixpanelAnalytics extends Analytics {
  constructor() {
    super();

    const apiHost = getEnvVar('VITE_MIXPANEL_API_HOST', {
      defaultValue: 'https://api-eu.mixpanel.com',
    });

    const isCustomApiHost = !apiHost.toLowerCase().includes('mixpanel.com');

    // custom api_routes for non-mixpanel.com api host
    const apiRoutes = isCustomApiHost
      ? {
          track: 't',
          engage: 'e',
          groups: 'g',
          flags: 'f',
          record: 'r',
        }
      : undefined;

    mixpanel.init(getEnvVar('VITE_MIXPANEL_PROJECT_TOKEN'), {
      api_host: apiHost,
      api_routes: apiRoutes,
      debug: getEnvVar('VITE_MIXPANEL_DEBUG') === 'true',
      autocapture: true,
      record_sessions_percent: 0,
      record_mask_text_selector: '',
      persistence: 'localStorage',
      persistence_name: `duos_${getEnvVar('VITE_MIXPANEL_PROJECT_TOKEN')}`,
    });
  }

  identify(userId: string) {
    mixpanel.identify(userId);
  }
  reset() {
    mixpanel.reset();
  }

  captureEvent(eventName: string, properties: EventProperties): void {
    mixpanel.track(eventName, properties);
  }

  setUserProperties(properties: EventProperties): void {
    const propsToSet: EventProperties = {};
    const propsToUnset: string[] = [];

    for (const [key, value] of Object.entries(properties)) {
      if (value !== null && value !== undefined) {
        propsToSet[key] = value;
      } else {
        propsToUnset.push(key);
      }
    }

    if (Object.keys(propsToSet).length > 0) {
      mixpanel.people.set(propsToSet);
    }

    if (propsToUnset.length > 0) {
      mixpanel.people.unset(propsToUnset);
    }
  }

  setGlobalProperties(properties: EventProperties): void {
    const propsToSet: EventProperties = {};

    for (const [key, value] of Object.entries(properties)) {
      if (value === null || value === undefined) continue;
      propsToSet[key] = value;
    }

    if (Object.keys(propsToSet).length === 0) return;

    mixpanel.register(propsToSet);
  }

  forceStartSessionRecording(): void {
    mixpanel.start_session_recording();
  }
}
